import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from '../../components/button/Button';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { isThunkLoading } from '../../redux/common';
import { saveInstagramLoginThunk, setInstagramLogin } from '../../redux/reducer/propSlice';
import { withErrorHandler } from '../../utils/utils';

enum Stage {
  DEV = 'dev',
  PROD = 'prod'
}
const INSTAGRAM_APP_ID = process.env.REACT_APP_STAGE === Stage.PROD ? 719112470594172 : 722452190297398;

const handleLogin = () => {
  const scope = ['instagram_business_basic'].join(',');

  const authUrl =
    `https://api.instagram.com/oauth/authorize` +
    `?client_id=${INSTAGRAM_APP_ID}` +
    `&redirect_uri=${encodeURIComponent(`https://${window.location.host}/website-details`)}` +
    `&scope=${encodeURIComponent(scope)}` +
    `&response_type=code`;

  window.location.href = authUrl;
};

export const InstagramLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const dispach = useAppDispatch();
  const navigate = useNavigate();
  const code = searchParams.get('code');
  const { websiteDetail, isLoading } = useAppSelector(state => state.prop);

  useEffect(() => {
    if (code) {
      withErrorHandler(async () => {
        await dispach(saveInstagramLoginThunk({ code })).unwrap();
        dispach(setInstagramLogin());
      }, 'Successfully Connected Instagram');

      navigate('/website-details', { replace: true });
    }
  }, [code]);

  return (
    <Button
      onClick={handleLogin}
      type="button"
      className="p-2 px-4"
      label={websiteDetail?.isInstagramConnected ? 'Instagram Connected' : 'Connect Instagram'}
      disabled={websiteDetail?.isInstagramConnected}
      isLoading={isThunkLoading(isLoading, saveInstagramLoginThunk)}
    />
  );
};
